"use client"

import { createRoute } from "@tanstack/react-router"

import { GraphiteSignIn } from "@/components/auth/graphite-sign-in"
import { rootRoute } from "@/App"


const AuthenticationPage = createRoute({
    getParentRoute: () => rootRoute,
    path: "/authentication",
    validateSearch: (search: Record<string, unknown>) => ({
      invite: typeof search.invite === "string" ? search.invite : undefined,
    }),
    component: Authentication,
})
export default AuthenticationPage

function Authentication() {
  const { invite } = AuthenticationPage.useSearch()

  // The whole screen is the component — artboards 13a–13d draw the page edge to
  // edge, with no wrapper, gradient or centred card of its own.
  return <GraphiteSignIn invite={invite} />
}
